import { createSlice } from "@reduxjs/toolkit";
import { updateJoiningStatus } from "./onboardingThunks";

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    list: [],
    single: null,
    loading: false,
  },
  reducers: {
    clearSingle: (state) => {
      state.single = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase("onboarding/fetch/pending", (state) => {
        state.loading = true;
      })
      .addCase("onboarding/fetch/fulfilled", (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase("onboarding/convert/fulfilled", (state, action) => {
        const id = action.meta.arg;
        
        const item = state.list.find(i => i.id === id);
        if (item) item.status = "converted";
      })
    .addCase("singleOnboarding/fetch/pending", (state) => {
      state.loading = true;
    })
    .addCase("singleOnboarding/fetch/fulfilled", (state, action) => {
      state.loading = false;
      state.single = action.payload;
    })
    .addCase(updateJoiningStatus.fulfilled,(state,action)=>{
    const item = state.list.find(
        i => i.id === action.meta.arg.id
    );
    if(item){
        item.status = action.payload.status ?? item.status;
        item.joining_status = action.meta.arg.joining_status;
        item.joining_status_reason = action.meta.arg.joining_status_reason;
        item.remarks = action.meta.arg.remarks;
    }

    });
  },
});

export const {clearSingle} = onboardingSlice.actions;

export default onboardingSlice.reducer;

